module.exports = __webpack_public_path__ + "static/img/HorseRacing.804dd762.png";